import { findContentfulFlagValue } from 'components/PageSections/utils';

import { StepCardListProps } from './StepCardList';

// TODO Update contentfulSection type
export const parseStepCardListData = (
  contentfulSection: any,
): StepCardListProps | null => {
  const {
    displayName,
    eyebrow,
    subsections,
    metadata: { title, flags, theme },
    body,
  } = contentfulSection;

  // Validate that all sections are added in Contentful
  if (!displayName && !subsections && !title) {
    return null;
  }

  const cards = subsections.map((subsection: any) => ({
    desktopImage: {
      gatsbyImageData: subsection?.images?.[0]?.desktopImage?.gatsbyImageData,
      description: subsection?.images?.[0]?.desktopImageAltText,
    },
    mobileImage: {
      // Fall to desktop image if mobile image is not available (backwards compatibility)
      gatsbyImageData:
        subsection?.images?.[0]?.mobileImage?.gatsbyImageData ||
        subsection?.images?.[0]?.desktopImage?.gatsbyImageData,
      description: subsection?.images?.[0]?.mobileImageAltText,
    },
    title: subsection.eyebrow || subsection.displayName,
    description: subsection.body,
    stepNumber: subsection?.metadata?.title,
  }));

  const isTitleRichText = findContentfulFlagValue('isTitleRichText', flags);
  const minified = findContentfulFlagValue('minified', flags);

  const arrowPosition = flags?.find(
    (flag: Queries.Maybe<Queries.ContentfulFlag001>) =>
      flag?.displayName === 'carouselArrowPosition',
  )?.metadata?.metadata_id as 'sides' | 'bottom' | 'top' | undefined;

  const slidesPerViewFlag = flags?.find(
    (flag: Queries.Maybe<Queries.ContentfulFlag001>) =>
      flag?.displayName === 'carouselSlidesPerView',
  );

  const slidesPerView = slidesPerViewFlag?.metadata?.metadata_id
    ? Number(slidesPerViewFlag.metadata.metadata_id)
    : undefined;

  return {
    eyebrow: eyebrow || displayName,
    eyebrowColor: theme?.textColor ?? 'viridian.base',
    title: title,
    titleColor: theme?.primaryColor ?? 'tints.black',
    cards: cards,
    body: {
      raw: body?.raw || '',
    },
    arrowPosition,
    slidesPerView,
    isTitleRichText,
    minified,
  };
};
